import { render, staticRenderFns } from "./KlientMedicom.vue?vue&type=template&id=202393de&scoped=true&"
import script from "./KlientMedicom.vue?vue&type=script&lang=js&"
export * from "./KlientMedicom.vue?vue&type=script&lang=js&"
import style0 from "./KlientMedicom.vue?vue&type=style&index=0&id=202393de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202393de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('202393de')) {
      api.createRecord('202393de', component.options)
    } else {
      api.reload('202393de', component.options)
    }
    module.hot.accept("./KlientMedicom.vue?vue&type=template&id=202393de&scoped=true&", function () {
      api.rerender('202393de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/klienti/KlientMedicom.vue"
export default component.exports